//import { datiReferenteTerzo } from './sezioni/sezioniAnagrafica';
import { datiReferenteTerzo } from './sezioni/sezioniAnagraficaReferenteTerzo';

export const referenteTerzoFisico = {
  anagraficaValida: null,
  controlloDati: '',
  datiReferenteTerzo: datiReferenteTerzo,
};